module.exports = {
      id: "Checkmark-lightblue-usage",
      viewBox: "0 0 20 20.604",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Checkmark-lightblue-usage",
      toString: function () {
        return this.url;
      }
    }